import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NgxPermissionsService } from 'ngx-permissions';
import {
  catchError,
  filter,
  first,
  map,
  mergeMap,
  Observable,
  of,
  withLatestFrom,
} from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthFacade } from '../+state/auth.facade';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedUserGuard {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private authService: AuthService,
    private router: Router,
    private authFacade: AuthFacade,
    private permissionsService: NgxPermissionsService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.signedIn$
      .pipe(
        mergeMap((isAuthenticated) => {
          if (isAuthenticated) {
            return this.checkStore();
          }
          // else if (location.href.indexOf('AADB2C90118') >= 0) {
          //   console.log('FORGOT PASSWORD TO IMPLEMENT');
          //   return of(false);
          // }
          else {
            this.router.navigateByUrl('/auth/login');
            return of(false);
          }
        }),
      )
      .pipe(catchError(() => of(false)));
  }

  checkStore(): Observable<boolean> {
    return this.authFacade.selectLoggedUser$.pipe(
      withLatestFrom(this.authService.userData$),
      map(([loggedUser, userData]) => {
        if (
          !loggedUser
          // ||(userData.userData &&
          //   loggedUser.externalUserId !== userData.userData.oid)
        ) {
          // loggedUser = undefined;
          this.authFacade.getLoggedUser();
        }
        return loggedUser;
      }),
      filter((loggedUser) => !!loggedUser),
      map((loggedUser) => {
        const permissions = (loggedUser?.role?.permissions || []).map(
          (rp) => rp.code || '',
        );
        // add role
        if (loggedUser?.role) {
          permissions.push(loggedUser?.role.code);
        }
        //console.log('permissions', permissions);
        this.permissionsService.loadPermissions(permissions);
        return !!loggedUser;
      }),
      first(),
    );
  }
}
